import React, { useState } from 'react';
import { ui } from './ui';
import { TYPES, TYPE_META } from './paperUtils';
import OptionsEditor from './OptionsEditor';

const SYMBOLS = ['√', '²', '³', 'π', '×', '÷', '≤', '≥', '≠', '±', '°', 'Δ', 'θ', '→', '∞', '½'];

// Controlled editor for a single question. All edits go through onChange(patch).
function QuestionCard({ q, index, onChange, onDelete, onDuplicate, onRegen, busy, onDragStart, onDropOn }) {
  const [open, setOpen] = useState(true);
  const [over, setOver] = useState(false);
  const set = onChange;
  const changeType = (type) => {
    const patch = { type };
    if (type === 'mcq' && (q.options || []).length < 2) patch.options = ['', '', '', ''];
    else if (type === 'match' && !(q.options || []).length) patch.options = [' :: ', ' :: ', ' :: ', ' :: '];
    else if (!['mcq', 'match'].includes(type)) patch.options = [];
    set(patch);
  };

  return (
    <div
      draggable
      onDragStart={(e) => { e.dataTransfer.setData('text/plain', q.id); onDragStart(q.id); }}
      onDragOver={(e) => { e.preventDefault(); setOver(true); }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => { e.preventDefault(); e.stopPropagation(); setOver(false); onDropOn(q.id); }}
      style={{ ...ui.card, padding: 10, marginBottom: 8, background: '#f8fafc', borderTop: over ? '3px solid #4f46e5' : '1px solid #e2e8f0' }}
    >
      <div style={ui.row}>
        <span title="Drag to reorder / move between sections" style={{ cursor: 'grab', fontSize: 16 }}>⠿</span>
        <b style={{ fontSize: 13 }}>Q{index + 1}</b>
        <select style={{ ...ui.input, width: 'auto' }} value={q.type} onChange={(e) => changeType(e.target.value)}>
          {TYPES.map((t) => <option key={t} value={t}>{TYPE_META[t]}</option>)}
        </select>
        <label style={{ fontSize: 12 }}>Marks{' '}
          <input type="number" min="0" step="0.5" style={{ ...ui.input, width: 60 }} value={q.marks} onChange={(e) => set({ marks: e.target.value === '' ? 0 : Number(e.target.value) })} />
        </label>
        <select style={{ ...ui.input, width: 'auto' }} value={q.difficulty || ''} onChange={(e) => set({ difficulty: e.target.value })} aria-label="Difficulty">
          <option value="">Difficulty…</option><option value="easy">Easy</option><option value="medium">Medium</option><option value="hard">Hard</option>
        </select>
        <button type="button" style={{ ...ui.btn, marginLeft: 'auto' }} onClick={() => setOpen(!open)}>{open ? 'Collapse' : 'Edit'}</button>
      </div>
      {!open && <div style={{ fontSize: 12, color: '#475569', marginTop: 4 }}>{(q.text || '(empty)').slice(0, 110)}</div>}
      {open && (
        <>
          <textarea style={{ ...ui.input, minHeight: 60, marginTop: 6 }} value={q.text} placeholder="Question text (supports **bold**, *italic*)" onChange={(e) => set({ text: e.target.value })} />
          <div style={{ ...ui.row, gap: 3, marginTop: 3 }}>
            {SYMBOLS.map((s) => <button key={s} type="button" style={{ ...ui.btn, padding: '2px 6px' }} onClick={() => set({ text: `${q.text}${s}` })}>{s}</button>)}
          </div>
          <OptionsEditor q={q} set={set} />
          <label style={{ ...ui.row, fontSize: 12, marginTop: 6 }}>
            <input type="checkbox" checked={q.hasOrChoice} onChange={(e) => set({ hasOrChoice: e.target.checked })} /> Internal choice (OR)
          </label>
          {q.hasOrChoice && <textarea style={{ ...ui.input, minHeight: 44 }} value={q.orQuestionText} placeholder="Alternative question (after OR)" onChange={(e) => set({ orQuestionText: e.target.value })} />}
          <div style={ui.grid2}>
            <div><span style={ui.label}>Correct answer</span><input style={ui.input} value={q.correctAnswer} onChange={(e) => set({ correctAnswer: e.target.value })} /></div>
            <div><span style={ui.label}>One-line hint</span><input style={ui.input} value={q.hint} onChange={(e) => set({ hint: e.target.value })} /></div>
          </div>
          <span style={ui.label}>Marking rubric (step-wise)</span>
          <input style={ui.input} value={q.rubric} onChange={(e) => set({ rubric: e.target.value })} placeholder="Step 1 (1m): … ; Step 2 (1m): …" />
          <div style={{ ...ui.row, marginTop: 8 }}>
            {onRegen && (
              <>
                <button type="button" disabled={busy} style={ui.btn} onClick={() => onRegen('')}>{busy ? '…' : '🔄 Regenerate'}</button>
                <button type="button" disabled={busy} style={ui.btn} onClick={() => onRegen('harder')}>⬆ Make harder</button>
                <button type="button" disabled={busy} style={ui.btn} onClick={() => onRegen('simpler')}>⬇ Make simpler</button>
              </>
            )}
            <button type="button" style={ui.btn} onClick={onDuplicate}>Duplicate</button>
            <button type="button" style={{ ...ui.btnDanger, marginLeft: 'auto' }} onClick={onDelete}>Delete</button>
          </div>
        </>
      )}
    </div>
  );
}

export default QuestionCard;
